import { Injectable } from '@angular/core';

import { ApplicationAdapter } from 'application/application.adapter';
import { ModulePageOutput } from 'module/model/page/module-page.output';
import { ModulePage } from 'module/page/module-page';
import { ModulePageI18n } from 'module/page/module-page-i18n';
import { ModulePageConverterPort } from 'module/page/port/module-page-converter.port';

@Injectable()
export class ModulePageConverterAdapter
	extends ApplicationAdapter
	implements ModulePageConverterPort
{
	public asModulePage(output: ModulePageOutput): ModulePage {
		if (!output) {
			return null;
		}

		return new ModulePage(
			output.id,
			output.position,
			output.type,
			output.updateTimestamp,
			(output.localizations || []).map(
				(loc) => new ModulePageI18n(loc.title, loc.locale, loc.text, loc.link)
			),
			(output.tasks || []).map((task) => task.id),
			(output.graphs || []).map((graph) => graph.id),
			(output.articles || []).map((article) => article.id),
			(output.questions || []).map((question) => question.id),
			(output.documents || []).map((document) => document.id)
		);
	}
}
